import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MetaTags from '../components/MetaTags';
import { getBreadcrumbSchema } from '../utils/schemaGenerator';
import { useTheme } from '../context/ThemeContext';

const TrustSafetyPage = () => {
  const { theme } = useTheme();
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Trust & Safety', url: '/trust-safety' }
  ]);

  return (
    <>
      <MetaTags
        title="Trust & Safety Guidelines | Genuine Auditions | BookMyAudition"
        description="Learn how BookMyAudition verifies casting directors, protects performers from fake auditions, and ensures a safe audition ecosystem in India."
        keywords="genuine acting auditions in India, verified casting calls, actor safety, safe auditions Mumbai, BookMyAudition trust"
        canonical="https://web.bookmyaudition.com/trust-safety"
        schema={breadcrumbSchema}
      />
      <div className="trust-safety-page" style={{ minHeight: '70vh', padding: '60px 0', backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc', color: theme === 'dark' ? '#f8fafc' : '#111' }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4">Trust & Safety</h1>
              <p className="mb-5">Your safety is our priority. Learn how we keep our community secure.</p>
              <div className="coming-soon-box p-5 rounded-4 shadow-sm" style={{ backgroundColor: theme === 'dark' ? '#111116' : '#fff', border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}` }}>
                <div className="d-inline-block mb-3 px-3 py-1 rounded-pill" style={{ backgroundColor: 'rgba(14, 165, 233, 0.1)', color: '#0ea5e9', fontSize: '0.85rem', fontWeight: '600' }}>SECURE PLATFORM</div>
                <h3>Guidelines Under Review</h3>
                <p className="text-muted">We are updating our community safety guidelines to ensure the best experience for everyone.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default TrustSafetyPage;